import React, { useRef, useState, useEffect, useMemo, useCallback } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";
import { connect, useSelector } from "react-redux";
import VideoPlayer from "../components/VideoPlayerOld";
import { Text, TextInput, TouchableOpacity } from "react-native";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import {
  FaPause,
  FaPlay,
  FaArrowRight,
  FaStopwatch,
  FaBug,
  FaSearch,
  FaSyncAlt,
  FaTrashAlt,
  FaEdit,
  FaVideo,
  FaCheckCircle,
  FaExclamationCircle,
  FaCheck,
  FaPlus,
  FaTimes,
  FaArrowLeft,
  FaArrowUp,
  FaArrowDown,
  FaAngleDown,
  FaAngleUp,
  FaLink,
} from "react-icons/fa";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import {
  fetchMatchStringById,
  getAllReviewerFeedbackStrings,
  matchReviewerIds,
  reviewRowsFor,
  runTechQC,
  saveReviewerFeedback,
} from "../config/mainRequest";
import { useHistory, useParams } from "react-router-dom";
import { pushCompletedTechQCString } from "../config/mainRequest";
import { createCheckpoint } from "../persistence/managers/CheckpointManager";
import Logo from "../assets/Logo";
import toast from "react-hot-toast";
import {
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  Modal,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import { ArrowBack, InfoOutlined, DarkModeOutlined, LightModeOutlined, OpenInNew, Groups } from "@mui/icons-material";
import LineupPopup from "../components/LineupPopup";
import {
  SaveStatusPill,
  SaveProblemBanner,
  EditingPausedOverlay,
  RecoveryBanner,
} from "../components/techqc/SaveStatus";
import { useThemeMode } from "../theme/ThemeContext";
import { v4 as uuidv4 } from "uuid";
import { FlatList, View } from "react-native-web";
import { useQuery } from "react-query";
import { List, AutoSizer } from "react-virtualized";
import "react-virtualized/styles.css";
import { CellMeasurer, CellMeasurerCache } from "react-virtualized";
import { EVENT_MAP } from "../constant/positionList";
import { useAbly } from "ably/react";
import { trackEvent } from "../utils/mixpanel";
import { trackGA } from "../utils/ga";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  type = "default",
  isDarkMode = false,
}) => {
  const getColors = () => {
    switch (type) {
      case "delete":
        return { bg: "#DA1414", hover: "#B91010" };
      case "update":
        return { bg: "#FF5A1F", hover: "#E54D18" };
      default:
        return { bg: "#007D48", hover: "#006838" };
    }
  };

  const colors = getColors();
  const modalBg = isDarkMode ? "#000" : "#fff";
  const modalText = isDarkMode ? "#fff" : "#111827";
  const cancelBg = isDarkMode ? "#000" : "#fff";
  const cancelHoverBg = isDarkMode ? "#111827" : "#F3F4F6";
  const cancelBorder = isDarkMode ? "#4B5563" : "#D1D5DB";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: modalBg,
          color: modalText,
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Stack spacing={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" component="h2" fontWeight={600} sx={{ color: modalText }}>
              {title}
            </Typography>
            <IconButton onClick={onClose} size="small" sx={{ color: isDarkMode ? "#E5E7EB" : "#666" }}>
              <FaTimes />
            </IconButton>
          </Stack>

          <Typography sx={{ color: modalText }}>{message}</Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              onClick={onClose}
              sx={{
                textTransform: "none",
                color: `${modalText} !important`,
                bgcolor: cancelBg,
                border: `1px solid ${cancelBorder}`,
                "&:hover": {
                  bgcolor: cancelHoverBg,
                  borderColor: isDarkMode ? "#6B7280" : "#9CA3AF",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{
                textTransform: "none",
                bgcolor: colors.bg,
                "&:hover": {
                  bgcolor: colors.hover,
                },
              }}
            >
              Confirm
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

const increaseTimestampByOneSecond = (timeString) => {
  if (!timeString) return timeString;

  const [hh, mm, ss] = timeString.split(":").map(Number);
  let totalSeconds = hh * 3600 + mm * 60 + ss + 1; // +1 second

  const newHH = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const newMM = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const newSS = String(totalSeconds % 60).padStart(2, "0");

  return `${newHH}:${newMM}:${newSS}`;
};

// Waits between automatic retries of a failed save (3 retries).
const SAVE_RETRY_DELAYS_MS = [1000, 2000, 4000];

const TechQC = (props) => {
  const { UpdateVideoTime, SetVideoControl, videoUrl, all_matches } = props;
  const { matchId } = useParams();
  const matchDetails = props.all_matches.find(
    (match) => String(match.id) === String(matchId)
  );
  const { analystId, token, role } = useSelector((state) => ({
    analystId: state.auth.analyst_id,
    token: state.auth.token,
    role: state.auth.accountRole,
  }));

  // Google Analytics helper — shared context on every event.
  const track = useCallback(
    (action, extra = {}) =>
      trackGA(action, {
        screen: "tech_qc",
        match_id: matchId,
        user_id: analystId,
        role,
        ...extra,
      }),
    [matchId, analystId, role]
  );

  

  const ably = useAbly();

  // ── Save queue ─────────────────────────────────────────────────────────────
  // Every Tech QC change goes through here: the whole match string plus any
  // reviewer-feedback calls. Each save is retried; while anything is unsaved the
  // analyst sees it, editing is paused, and the pending change is kept in this
  // browser so a closed tab or lost connection doesn't lose it.
  const [saveState, setSaveState] = useState({ status: "saved", error: null, savedAt: null });
  const [isOnline, setIsOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [recoveredSave, setRecoveredSave] = useState(null);
  const pendingSaveRef = useRef(null); // { string, savedString, reviewOps: [body], trigger }
  const flushPromiseRef = useRef(null);
  const pendingSaveKey = `techqc-pending-save-${matchId}-${analystId}`;

  const storePendingSave = (pending) => {
    try {
      if (pending) {
        window.localStorage.setItem(
          pendingSaveKey,
          JSON.stringify({ string: pending.string, reviewOps: pending.reviewOps, at: Date.now() })
        );
      } else {
        window.localStorage.removeItem(pendingSaveKey);
      }
    } catch (e) {
      // Storage unavailable: the in-memory queue still retries this visit.
    }
  };

  const withRetries = async (attempt) => {
    let lastError;
    for (let i = 0; i <= SAVE_RETRY_DELAYS_MS.length; i += 1) {
      try {
        return await attempt();
      } catch (err) {
        lastError = err;
        if (!navigator.onLine || i === SAVE_RETRY_DELAYS_MS.length) break;
        await new Promise((resolve) => setTimeout(resolve, SAVE_RETRY_DELAYS_MS[i]));
      }
    }
    throw lastError;
  };

  const runSaveQueue = async () => {
    setSaveState((prev) => ({ ...prev, status: "saving", error: null }));
    let lastSaved = null;
    let trigger = "techqc-edit";
    while (pendingSaveRef.current) {
      const pending = pendingSaveRef.current;
      trigger = pending.trigger || trigger;
      if (pending.string !== pending.savedString) {
        const toSave = pending.string;
        await withRetries(async () => {
          const result = await pushCompletedTechQCString(matchId, analystId, token, toSave, 1);
          if (!result?.success) throw new Error(result?.error || "the server rejected the save");
        });
        pending.savedString = toSave;
        lastSaved = toSave;
      } else if (pending.reviewOps.length) {
        const body = pending.reviewOps[0];
        await withRetries(() => saveReviewerFeedback({ token, body }));
        pending.reviewOps.shift();
      } else {
        pendingSaveRef.current = null;
      }
    }
    storePendingSave(null);
    if (lastSaved !== null) {
      createCheckpoint({
        matchId: String(matchId),
        analystId: String(analystId),
        currentString: lastSaved,
        triggerType: trigger,
        skipFirestore: true, // server already has this string — no Firestore backup needed
      }).catch(() => {});
      ably.channels.get(`match-${matchId}`).publish("match-string-updated", { matchId, updatedAt: Date.now() });
    }
    setSaveState({ status: "saved", error: null, savedAt: Date.now() });
    return true;
  };

  // Resolves true once everything queued is on the server, false if it isn't.
  const flushSaves = () => {
    if (flushPromiseRef.current) return flushPromiseRef.current;
    if (!pendingSaveRef.current) return Promise.resolve(true);
    if (!navigator.onLine) {
      setSaveState((prev) => ({ ...prev, status: "offline" }));
      return Promise.resolve(false);
    }
    flushPromiseRef.current = runSaveQueue()
      .catch((err) => {
        storePendingSave(pendingSaveRef.current);
        setSaveState((prev) => ({
          ...prev,
          status: navigator.onLine ? "failed" : "offline",
          error: err?.message || "request failed",
        }));
        track("tech_qc_save_failed", { error: String(err?.message || err).slice(0, 100) });
        return false;
      })
      .finally(() => {
        flushPromiseRef.current = null;
      });
    return flushPromiseRef.current;
  };

  // Queues the full match string (and reviewer-feedback bodies) and saves it.
  const saveMatchString = (matchStringValue, { reviewOps = [], trigger = "techqc-edit" } = {}) => {
    const pending = pendingSaveRef.current ?? { string: null, savedString: null, reviewOps: [] };
    pending.string = matchStringValue;
    pending.reviewOps.push(...reviewOps);
    pending.trigger = trigger;
    pendingSaveRef.current = pending;
    storePendingSave(pending);
    return flushSaves();
  };

  const hasUnsavedWork = saveState.status !== "saved" || !isOnline;

  useEffect(() => {
    const goOnline = () => {
      setIsOnline(true);
      if (pendingSaveRef.current) flushSaves();
    };
    const goOffline = () => {
      setIsOnline(false);
      if (pendingSaveRef.current) setSaveState((prev) => ({ ...prev, status: "offline" }));
    };
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Warn before closing the tab or leaving Tech QC with unsaved work.
  useEffect(() => {
    if (saveState.status === "saved") return undefined;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [saveState.status]);

  // A previous visit's unsaved change, offered back to the analyst once.
  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(pendingSaveKey);
      if (raw) setRecoveredSave(JSON.parse(raw));
    } catch (e) {
      setRecoveredSave(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingSaveKey]);
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [showControls, setShowControl] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  // Narrows the "Review Errors" filter to one reviewer's open errors.
  const [reviewerFilter, setReviewerFilter] = useState("all");
  const matchesReviewerFilter = (item) =>
    activeFilter !== "review_error" ||
    reviewerFilter === "all" ||
    (item.reviewEntries ?? []).some(
      (r) => r.string_status === 0 && String(r.reviewer_id) === reviewerFilter
    );
  const playerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [initialEventDetails, setInitialEventDetails] = useState({});
  const [hasInitialized, setHasInitialized] = useState(false);
  const history = useHistory();

  // Leaving Tech QC inside the app with unsaved work asks first.
  useEffect(() => {
    if (!hasUnsavedWork) return undefined;
    return history.block(
      "Some Tech QC changes are not saved yet. Leave anyway? They are kept on this computer and offered again next time."
    );
  }, [hasUnsavedWork, history]);
  const [lineupPopupOpen, setLineupPopupOpen] = useState(false);
  const [isRunningQC, setIsRunningQC] = useState(false);
  const [IsInitialQC, setIsInitialQC] = useState(false);
  // Every reviewer's feedback is shown; reviewerId (the first reviewer) only
  // receives updates for strings no reviewer has commented on.
  const reviewerIds = matchReviewerIds(matchDetails, analystId);
  const reviewerId = reviewerIds[0];
  const reviewQueryEnabled = Boolean(matchDetails) && reviewerIds.length > 0;
  // The reviewer-feedback map the event list was last built with, so the
  // Event Details snapshot is only taken once feedback is reflected in it.
  const [reviewMergedFor, setReviewMergedFor] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const listRef = useRef(null);
  const [currentErrorGlobalIndex, setCurrentErrorGlobalIndex] = useState(-1);
  const [searchStringValue, setSearchStringValue] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const [skipScrollToIndex, setSkipScrollToIndex] = useState(false);
  const [qcResultModal, setQcResultModal] = useState(null);
  const [urlInput, setUrlInput] = useState("");
  const [showUrlInput, setShowUrlInput] = useState(false);

  const { mode: themeMode, toggleMode } = useThemeMode();

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("theme-dark"),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("theme-dark"));
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);
  const [searchMatchIndexes, setSearchMatchIndexes] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);
  // Modal states
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    value: "",
  });
  const [updateModal, setUpdateModal] = useState({
    open: false,
    id: null,
    oldValue: "",
    newValue: {},
  });

  const {
    data: reviewStrings,
    refetch: refetchReviewerStrings,
    isLoading: reviewStringsLoading,
    isError: reviewStringsFailed,
    isFetched: reviewStringsFetched,
  } = useQuery({
    queryKey: ["getReviewerStrings", matchId, reviewerIds.join(",")],
    queryFn: () => getAllReviewerFeedbackStrings({ matchId, token, reviewerIds }),
    enabled: reviewQueryEnabled,
  });

  // Process review strings to create a map of string -> review data
  const reviewStringMap = React.useMemo(() => {
    if (!reviewStrings?.string_details) return new Map();

    const map = new Map();
    Object.entries(reviewStrings.string_details).forEach(([key, value]) => {
      map.set(key.trim(), value);
    });
    return map;
  }, [reviewStrings]);

  const handleLogout = () => {
    console.log("Logout clicked");
    // Logout logic here
  };

  const isYoutubeUrl = () => {
    if (videoUrl ?? matchDetails?.youtube_videos[0]?.url) {
      const hostname = new URL(videoUrl ?? matchDetails?.youtube_videos[0]?.url)
        .hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
    track("tech_qc_video_seek", { seek_to: parseFloat(e.target.value) });
  };

  const full = () => {
    track("tech_qc_fullscreen");
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  const handleMute = () => {
    track("tech_qc_video_mute", { muted: !isMute });
    setIsMute(!isMute);
  };

  const jumpManually = (str) => {
    const jumpInputList = str?.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
    track("tech_qc_jump_to_time", { time: str });
  };

  // Google Analytics – screen view on mount.
  useEffect(() => {
    track("tech_qc_screen_view");
  }, [track]);

  // Track playback-speed changes (skip the initial mount value).
  const _speedTracked = useRef(false);
  useEffect(() => {
    if (!_speedTracked.current) { _speedTracked.current = true; return; }
    track("tech_qc_video_speed", { speed });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speed]);

  const [matchString, setMatchString] = useState([]);
  const [fetchedQcData, setFetcheddQcData] = useState();
  const [transformedStrings, setTransformedStrings] = useState();

  const transformMatchStrings = (qcData) => {
    if (!qcData) return [];

    return qcData.reduce((acc, item) => {
      if (!Array.isArray(item.examples)) return acc;

      const { error_type, message, examples } = item;

      const transformed = examples.map((example) => ({
        id: uuidv4(),
        value: example,
        type: error_type.toLowerCase(),
        message,
        ignored: false,
      }));

      return acc.concat(transformed);
    }, []);
  };

  useEffect(() => {
    const getMatchString = async () => {
      try {
        setIsLoading(true);
        const result = await fetchMatchStringById(matchId, analystId, token);
        setMatchString(
          result?.temp_string?.split(",").map((str) => str.trim())
        );
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchId && analystId && token) {
      getMatchString();
    }
  }, [matchId, analystId, token]);

  const visibleErrorGlobalIndexes = React.useMemo(() => {
    if (!transformedStrings || transformedStrings.length === 0) return [];

    const search = (searchStringValue || "").trim().toLowerCase();

    return transformedStrings.reduce((acc, item, idx) => {
      const isErrorType =
        item.type === "error" ||
        item.type === "warning" ||
        item.type === "review_error";

      if (!isErrorType) return acc;

      if (activeFilter !== "all" && item.type !== activeFilter) return acc;
      if (!matchesReviewerFilter(item)) return acc;

      if (!search) {
        acc.push(idx);
        return acc;
      }

      const timestamp = (item?.value?.split("-")?.at(6) || "").toLowerCase();

      if (["error", "warning", "review_error"].includes(item.type)) {
        acc.push(idx);
        return acc;
      }

      if (timestamp.includes(search)) {
        acc.push(idx);
      }

      return acc;
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transformedStrings, activeFilter, reviewerFilter, searchStringValue]);

  useEffect(() => {
    if (matchString?.length === 0) return;
    const runTechQCString = async () => {
      const stringArray = matchString
        .map((item) => (typeof item === "string" ? item : item?.value))
        .filter(Boolean);

      try {
        setIsInitialQC(true);
        // Mixpanel – run analysis (initial auto-load)
        trackEvent().track('run_onload_qc_analysis', {
          match_id: matchId,
          trigger: 'initial_load_on_tech_qc_screen',
          string_event_count: stringArray.length,
        });
        track('run_onload_qc_analysis', { trigger: 'initial_load', string_event_count: stringArray.length });
        const qcResult = await runTechQC(stringArray, token, matchId);
        setFetcheddQcData(qcResult?.qc_results);
        setIsInitialQC(false);
      } catch (error) {
        setIsInitialQC(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchString && token) {
      runTechQCString();
    }
  }, [matchId, matchString, token]);

  // helper to merge raw qc results with existing transformed strings
  const mergeMatchStringsWithErrors = (
    baseStrings,
    qcData,
      existingTransformed = null
  ) => {
    const errors = transformMatchStrings(qcData);

    const errorMap = new Map();
    const parseErrorValue = (value) => {
      const strings = [];

      let cleanValue = value;
      if (value.includes(":")) {
        const colonIndex = value.indexOf(":");
        if (colonIndex < 50 && value[colonIndex + 1] === " ") {
          cleanValue = value.substring(colonIndex + 1).trim();
        }
      }

      // arrow notation
      if (cleanValue.includes("->")) {
        const parts = cleanValue.split("->").map((p) => p.trim());
        strings.push(...parts.filter(Boolean));
      } else if (cleanValue.includes(",")) {
        //  csv values
        const parts = cleanValue.split(",").map((p) => p.trim());
        strings.push(...parts.filter(Boolean));
      } else {
        // Single value
        strings.push(cleanValue.trim());
      }

      return strings.filter(Boolean);
    };

    errors.forEach((item) => {
      if (item.value) {
        const parts = parseErrorValue(item.value);

        parts.forEach((part) => {
          const existing = errorMap.get(part.trim());

          if (existing) {
            existing.push(item);
          } else {
            errorMap.set(part.trim(), [item]);
          }
        });
      }
    });

    const normalize = (v) =>
      typeof v === "string" ? v.trim() : v?.value?.trim();

    // If we have existing transformedStrings (manual additions), store them
    if (existingTransformed && existingTransformed?.length > 0) {
      return existingTransformed.map((str) => {
        const value = normalize(str);
        const errorArray = errorMap.get(value);
        const reviewData = reviewStringMap.get(value);

        // Determine type and message based on QC
        let finalType = "noIssue";
        let finalMessage = null;

        if (errorArray) {
          // Error takes priority over warning
          const hasErrors = errorArray.some((err) => err.type === "error");
          const hasWarnings = errorArray.some((err) => err.type === "warning");
          if (hasErrors) {
            finalType = "error";
            finalMessage = errorArray.filter((err) => err.type === "error").map((err) => err.message).join(" | ");
          } else if (hasWarnings) {
            finalType = "warning";
            finalMessage = errorArray.filter((err) => err.type === "warning").map((err) => err.message).join(" | ");
          }
        }

        // Review errors override QC result
        if (reviewData?.string_status === 0) {
          finalType = "review_error";
          finalMessage = reviewData?.comments || "Pending review feedback";
        }

         const isIgnored =
        reviewData?.string_status === 3 || (reviewData?.string_status === 2 && !!reviewData?.comments) || str.ignored === true || str.reviewStatus === 3;
          // Only block "ignored" when there are actual errors (not warnings)
          const hasActualErrors = errorArray?.some((err) => err.type === "error");
          if (isIgnored && !hasActualErrors) {
          finalType = "ignored";
          finalMessage = str.message || reviewData?.comments || finalMessage;
        }

        return {
          ...str,
          id: uuidv4(),
          issues: errorArray || [],
          type: finalType,
          message: finalMessage,
          ignored: isIgnored,
          reviewStatus: reviewData?.string_status,
          reviewComments: reviewData?.comments,
          reviewEntries: reviewData?.byReviewer ?? [],
        };
      });
    }

    // Initial load or no existing transformed strings - use baseStrings
    return baseStrings.map((str) => {
      const value = str?.trim();
      const errorArray = errorMap.get(value);
      const reviewData = reviewStringMap.get(value);

      // Determine type based on errors and review status
      let finalType = "noIssue";
      let finalMessage = null;

      if (errorArray) {
        // Error takes priority over warning
        const hasErrors = errorArray.some((err) => err.type === "error");
        const hasWarnings = errorArray.some((err) => err.type === "warning");
        if (hasErrors) {
          finalType = "error";
          finalMessage = errorArray.filter((err) => err.type === "error").map((err) => err.message).join(" | ");
        } else if (hasWarnings) {
          finalType = "warning";
          finalMessage = errorArray.filter((err) => err.type === "warning").map((err) => err.message).join(" | ");
        }
      }

      // If review status is 0 (Pending), mark as review_error
      if (reviewData?.string_status === 0) {
        finalType = "review_error";
        finalMessage = reviewData?.comments || "Pending review feedback";
      }

      // id status is 3 then mark it as ignore if status is 2 from reviewer side and comment is present consider it as ignored as for error status is 1
      const isIgnored =
        reviewData?.string_status === 3 || (reviewData?.string_status === 2 && !!reviewData?.comments);
      // Only block "ignored" when there are actual errors (not warnings)
       const hasActualErrors = errorArray?.some((err) => err.type === "error");
       if (isIgnored && !hasActualErrors) {
          finalType = "ignored";
        }

      return {
        value: value,
        id: uuidv4(),
        issues: errorArray || [],
        type: finalType,
        message: finalMessage,
        ignored: isIgnored,
        reviewStatus: reviewData?.string_status,
        reviewComments: reviewData?.comments,
        reviewEntries: reviewData?.byReviewer ?? [],
      };
    });
  };

  useEffect(() => {
    if (matchString?.length > 0 && fetchedQcData?.length >= 0) {
      setTransformedStrings((transformedStrings) => {
        const base =
          transformedStrings?.length > 0
            ? transformedStrings.map((s) => s.value)
            : matchString;

        const merged = mergeMatchStringsWithErrors(
          base,
          fetchedQcData,
          transformedStrings
        );

        return merged;
      });
      setReviewMergedFor(reviewStringMap);
    }
  }, [matchString, fetchedQcData, reviewStringMap]);

  const updateTag = async (id, newValue) => {
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (!oldItem) {
      console.warn("Item not found for update");
      return;
    }

    const valueChanged = oldItem.value !== newValue.value;

    // If type is "fixed" and value hasn't changed (e.g. from Mark as Fixed button), just update state
    if (newValue.type === "fixed" && !valueChanged) {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );
      setTransformedStrings(updatedArray);
      return;
    }

    // If item is a warning and value hasn't changed, just update state
    if (oldItem.type === "warning" && !valueChanged) {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );

      setTransformedStrings(updatedArray);

      return;
    }

    // If type is "ignored" and value hasn't changed, just update state
    if (newValue.type === "ignored" && !valueChanged) {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );
      setTransformedStrings(updatedArray);
      return;
    }

    // If value hasn't changed at all (blur without editing), no-op
    if (!valueChanged) {
      return;
    }

    // Value was changed — open confirmation modal
    setUpdateModal({
      open: true,
      id,
      oldValue: oldItem.value,
      newValue: { ...oldItem, ...newValue },
    });
  };

  const confirmUpdate = async () => {
    const { id, oldValue, newValue } = updateModal;
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (
      oldItem.type === "error" ||
      oldItem.type === "warning" ||
      oldItem.type === "review_error"
    ) {
      newValue.type = "fixed";
      newValue.message = "Issue resolved";
    }

    const updatedArray = transformedStrings.map((item) =>
      item.id === id ? { ...item, ...newValue, id: item.id } : item
    );

    // Mixpanel – analyst made a fix/change in TechQC
    trackEvent().track('tech_qc_perform_update_before_api_call', {
      match_id: matchId,
      previous_event_string: oldValue,
      changed_event_string: newValue?.value ?? '',
    });
    track('tech_qc_edit_string', {
      previous_event_string: oldValue,
      changed_event_string: newValue?.value ?? '',
    });

    // UPDATE STATE
    setTransformedStrings(updatedArray);

    setTimeout(() => {
      const index = updatedArray.findIndex((s) => s.id === id);
      for (let i = index; i <= updatedArray.length - 1; i++) {
        cache.current.clear(i, 0);
      }

      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
    }, 0);
    // API update
    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    // A fixed review error also updates the reviewer's feedback: the old string's
    // entry is removed and the new string is marked fixed (status 1).
    // Each reviewer who flagged the string gets their own update.
    const reviewOps =
      oldItem.type === "review_error"
        ? reviewRowsFor(oldItem, reviewerId).map((row) => ({
            match_id: Number(matchId),
            reviewer_id: row.reviewer_id,
            string_details: [
              {
                string: oldItem.value,
                string_status: row.string_status,
                comments: row.comments,
                delete: true,
              },
              { string: newValue.value, string_status: 1, comments: row.comments },
            ],
          }))
        : [];
    const editSaved = await saveMatchString(stringArray, { reviewOps, trigger: "techqc-edit" });
    // Mixpanel – FORCE_UPDATE 1 push called from update
    trackEvent().track('tech_qc_force_update', {
      match_id: matchId,
      trigger: 'update',
      previous_event_string: oldValue,
      changed_event_string: newValue?.value ?? '',
      string_event_count: updatedArray.length,
    });
    track('tech_qc_confirm_update', {
      previous_event_string: oldValue,
      changed_event_string: newValue?.value ?? '',
      string_event_count: updatedArray.length,
    });

    if (editSaved && oldItem.type === "review_error") toast.success("Feedback saved!");

    setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} });
  };

  useEffect(() => {
    if (skipScrollToIndex) {
      setSkipScrollToIndex(false);
    }
  }, [transformedStrings]);

  const addTag = (afterId) => {
    track("tech_qc_add_string");
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);

    setTransformedStrings((prevStrings) => {
      const index = prevStrings.findIndex((item) => item.id === afterId);
      if (index === -1) return prevStrings;

      const newItem = {
        id: uuidv4(),
        value: " ",
        type: "noIssue",
        message: null,
        ignored: false,
      };

      setTimeout(() => {
        const startIndex = Math.max(0, index);
        for (let i = startIndex; i <= updated.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }, 0);

      const updated = [...prevStrings];
      updated.splice(index + 1, 0, newItem);
      return updated;
    });
  };

  const runTechQCManually = async () => {
    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      setIsRunningQC(true);
      // Mixpanel – run analysis (manual trigger)
      trackEvent().track('run_tech_qc_manually', {
        match_id: matchId,
        trigger: 'manual',
        string_event_count: stringArray.length,
      });
      track('run_tech_qc_manually', { trigger: 'manual', string_event_count: stringArray.length });
      const qcResult = await runTechQC(stringArray, token, matchId);
      setFetcheddQcData(qcResult.qc_results);
      const base = transformedStrings?.length > 0 ? transformedStrings.map((s) => s.value) : stringArray;
      const merged = mergeMatchStringsWithErrors(base, qcResult.qc_results, transformedStrings);
      setTransformedStrings(merged);

      if (listRef.current) {
        cache.current.clearAll();
        // listRef.current.recomputeRowHeights();
        listRef.current.scrollToPosition(scrollPosition);
      }

      setQcResultModal({
        errorCount: merged.filter((i) => i.type === "error").length,
        reviewErrorCount: merged.filter((i) => i.type === "review_error").length,
        warningCount: merged.filter((i) => i.type === "warning").length,
        noErrorsCount: merged.filter((i) => i.type === "noIssue").length,
        total: merged.length,
      });
      setIsRunningQC(false);
    } catch (error) {
      console.error("Failed to fetch match string", error);
      toast.error("Failed to Run QC");
      setIsRunningQC(false);
    }
  };

  const handleSubmitFinalQC = async () => {
    if (isSubmitting) return;
    if (!navigator.onLine) {
      toast.error("You're offline. Reconnect to submit Tech QC.");
      return;
    }
    if (saveState.status !== "saved") {
      toast.error("Some changes aren't saved yet. Retry the save before submitting.");
      return;
    }

    setIsSubmitting(true);

    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      // Mixpanel – run analysis (final submit)
      trackEvent().track('run_tech_qc_analysis_done', {
        match_id: matchId,
        trigger: 'final_submit',
        string_event_count: stringArray.length,
      });
      track('tech_qc_submit_final', { trigger: 'final_submit', string_event_count: stringArray.length });
      const qcResult = await runTechQC(stringArray, token, matchId);
      const latestQC = qcResult?.qc_results || [];
      // logic to update the ui based on the new errros and maintain scroll position.
      setFetcheddQcData(qcResult?.qc_results);
      // merge errors into transformedStrings right away so new strings show status
      setTransformedStrings((prev) => {
        const base = prev?.length > 0 ? prev.map((s) => s.value) : stringArray;
        return mergeMatchStringsWithErrors(base, qcResult?.qc_results, prev);
      });
      cache.current.clearAll();
      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
      const qcIssues = latestQC.flatMap((item) =>
        item.examples.map((ex) => ({
          str: ex,
          type: item.error_type.toLowerCase(),
        }))
      );

      let actualErrors = 0;
      let actualWarnings = 0;

      stringArray.forEach((str) => {
        const issuesForStr = qcIssues.filter((i) => i.str === str);
        const hasError = issuesForStr.some((i) => i.type === "error");
        const hasWarning = issuesForStr.some((i) => i.type === "warning");
        const uiItem = transformedStrings.find((item) => item.value === str);
        const isIgnored =
          uiItem?.type === "ignored" || uiItem?.reviewStatus === 3;

        if (hasError && isIgnored) return;
        if (hasError && hasWarning) return;
        if (hasWarning && isIgnored) return;
        if (hasWarning) actualWarnings++;
        if (hasError) actualErrors++;
      });

      if (actualErrors > 0 || actualWarnings > 0) {
        toast.error("QC Failed! Fix all errors/warnings before submitting.");
        setIsSubmitting(false);
        return;
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to run QC before final submission.");
      setIsSubmitting(false);
      return;
    }

    const updatedArray = [...stringArray];
    // let lastStr = updatedArray[updatedArray.length - 1];
    // let parts = lastStr.split("-");

    // if (parts[6]) {
    //   parts[6] = increaseTimestampByOneSecond(parts[6]);
    //   updatedArray[updatedArray.length - 1] = parts.join("-");
    // }

    const finalMatchString = updatedArray.join(",");

    let result;
    try {
      await withRetries(async () => {
        const pushed = await pushCompletedTechQCString(matchId, analystId, token, finalMatchString, 1);
        if (!pushed?.success) throw new Error(pushed?.error || "the server rejected the save");
      });
      result = { success: true };
    } catch (err) {
      result = { success: false, error: err?.message };
    }
    // Mixpanel – FORCE_UPDATE 1 push called from final TechQC submission
    trackEvent().track('tech_qc_final_force_update', {
      match_id: matchId,
      trigger: 'final_submit',
      string_event_count: updatedArray.length,
    });
    track('tech_qc_final_force_update', { trigger: 'final_submit', string_event_count: updatedArray.length });

    if (result.success) {
      toast.success("Match String Saved Successfully");
      createCheckpoint({
        matchId:       String(matchId),
        analystId:     String(analystId),
        currentString: finalMatchString,
        triggerType:   "techqc-submit",
        skipFirestore: true,  // server already has this string — no Firestore backup needed
      }).catch(() => {});
      ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
        matchId,
        updatedAt: Date.now(),
      });
      setTimeout(() => {
        history.push(`/videoplayerold?match_id=${matchId}`, {
          TechQCSubmit: true,
        });
      }, 800);
    } else {
      toast.error(
        `Tech QC was not submitted: the match string couldn't be saved after 3 tries${
          result.error ? ` (${result.error})` : ""
        }. Check your connection and press Mark Analysis Done again.`,
        { duration: 8000 }
      );
    }

    setIsSubmitting(false);
  };

  const deleteStringByIndex = async (id) => {
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);
    const item = transformedStrings?.find((s) => s.id === id);

    // Open modal instead of directly deleting
    setDeleteModal({
      open: true,
      id,
      value: item?.value || "",
    });
  };

  const confirmDelete = async () => {
    const { id } = deleteModal;

    const item = transformedStrings?.find((s) => s.id === id);
    const deleteIndex = transformedStrings.findIndex((s) => s.id === id);

    // A deleted review error is also removed from the reviewer's feedback.
    const deleteReviewOps =
      item?.type === "review_error"
        ? reviewRowsFor(item, reviewerId, { all: true }).map((row) => ({
            match_id: Number(matchId),
            reviewer_id: row.reviewer_id,
            string_details: [
              { string: item.value, string_status: row.string_status, comments: row.comments, delete: true },
            ],
          }))
        : [];

    setTimeout(() => {
      if (deleteIndex !== -1) {
        const startIndex = Math.max(0, deleteIndex);

        for (let i = startIndex; i <= updatedArray.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }
    }, 0);
    const updatedArray = transformedStrings.filter((s) => s.id !== id);
    setTransformedStrings(updatedArray);

    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    setDeleteModal({ open: false, id: null, value: "" });
    const deleteSaved = await saveMatchString(stringArray, { reviewOps: deleteReviewOps, trigger: "techqc-delete" });
    // Mixpanel – FORCE_UPDATE 1 push called from delete
    trackEvent().track('tech_qc_force_update_deleting_string', {
      match_id: matchId,
      trigger: 'delete',
      deleted_string: deleteModal.value,
      string_event_count: updatedArray.length,
    });
    track('tech_qc_delete_string', { deleted_string: deleteModal.value, string_event_count: updatedArray.length });
    if (deleteSaved) toast.success("String deleted successfully");
  };

  // useEffect(() => {
  //   if (listRef?.current) {
  //     // eslint-disable-next-line no-unused-expressions
  //     listRef.current?.forceUpdateGrid();
  //   }
  // }, [searchStringValue, activeFilter]);

  const warningCount = transformedStrings?.filter(
    (item) => item.type === "warning"
  ).length;

  const errorCount = transformedStrings?.filter(
    (item) => item.type === "error"
  ).length;

  const noErrorsCount = transformedStrings?.filter(
    (item) => item.type === "noIssue"
  ).length;

  const reviewErrorCount = transformedStrings?.filter(
    (item) => item.type === "review_error"
  ).length;

  // Feedback has loaded (or failed) and the event list was rebuilt with it.
  const reviewFeedbackReflected =
    (!reviewQueryEnabled || reviewStringsFetched) && reviewMergedFor === reviewStringMap;

  useEffect(() => {
    if (
      warningCount >= 0 &&
      errorCount >= 0 &&
      reviewErrorCount >= 0 &&
      noErrorsCount >= 0 &&
      reviewFeedbackReflected &&
      !hasInitialized
    ) {
      const details = {
        warning: warningCount,
        error: errorCount,
        reviewError: reviewErrorCount,
        noIssue: noErrorsCount,
        total: transformedStrings.length,
      };
      setInitialEventDetails(details);
      setHasInitialized(true);
    }
  }, [
    errorCount,
    reviewErrorCount,
    noErrorsCount,
    warningCount,
    hasInitialized,
    reviewFeedbackReflected,
    transformedStrings?.length,
  ]);

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const details = all_matches?.find((m) => {
    return m.id.toString() === matchId;
  });
  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 180,
    })
  );

  const goToNextError = () => {
    if (activeFilter !== "all") return;
    track("tech_qc_next_error");

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const first = list[0];
    //   setCurrentErrorGlobalIndex(first);
    //   // eslint-disable-next-line no-unused-expressions
    //   listRef.current?.scrollToRow(first);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const nextPos = (currentIndexPos + 1) % list.length;
    const nextGlobalIndex = list[nextPos];

    setCurrentErrorGlobalIndex(nextGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(nextGlobalIndex);
  };

  const goToPrevError = () => {
    if (activeFilter !== "all") return;
    track("tech_qc_prev_error");

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const last = list[list.length - 1];
    //   setCurrentErrorGlobalIndex(last);
    //   // eslint-disable-next-line no-unused-expressions
    //   listRef.current?.scrollToRow(last);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const prevPos = (currentIndexPos - 1 + list.length) % list.length;
    const prevGlobalIndex = list[prevPos];

    setCurrentErrorGlobalIndex(prevGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(prevGlobalIndex);
  };

  const filteredData = useMemo(() => {
    if (!transformedStrings) return [];

    return transformedStrings.filter((item) => {
      if (activeFilter !== "all" && item.type !== activeFilter) {
        return false;
      }
      return matchesReviewerFilter(item);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transformedStrings, activeFilter, reviewerFilter]);

  // Per reviewer, over events in the current string: how many have their
  // feedback, and how many of those are open review errors.  Shared by the
  // reviewer card and the reviewer filter so their numbers match the list.
  const reviewerCountsInString = useMemo(() => {
    const counts = new Map();
    (transformedStrings ?? []).forEach((item) => {
      (item.reviewEntries ?? []).forEach((r) => {
        const key = String(r.reviewer_id);
        const c = counts.get(key) ?? { checked: 0, open: 0 };
        c.checked += 1;
        if (item.type === "review_error" && r.string_status === 0) c.open += 1;
        counts.set(key, c);
      });
    });
    return counts;
  }, [transformedStrings]);

  const lineNumberMap = useMemo(() => {
    if (!transformedStrings) return new Map();
    const map = new Map();
    transformedStrings.forEach((item, idx) => map.set(item.id ?? item.value, idx + 1));
    return map;
  }, [transformedStrings]);

  //   const filteredData = useMemo(() => {
  //   if (!transformedStrings) return [];

  //   const search = (searchStringValue || "").trim().toLowerCase();

  //   return transformedStrings.filter((item) => {
  //     if (activeFilter !== "all" && item.type !== activeFilter) {
  //       return false;
  //     }

  //     if (!search) {
  //       return true;
  //     }

  //     const parts = item.value?.split("-") || [];
  //     const timestamp = (parts[6] || "").toLowerCase();

  //     return (
  //       timestamp.includes(search) || item.value.toLowerCase().includes(search)
  //     );
  //   });
  // }, [transformedStrings, activeFilter, searchStringValue]);

  useEffect(() => {
    cache.current.clearAll();

    if (listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [activeFilter]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!playerRef.current) return;

      switch (e.key) {
        case " ":
          e.preventDefault();
          track("tech_qc_video_playpause", { playing: !props.videoControl, source: "keyboard" });
          props.SetVideoControl(!props.videoControl);
          break;

        case "ArrowRight":
          playerRef.current.seekTo(props.videoTime + 5);
          break;

        case "ArrowLeft":
          playerRef.current.seekTo(props.videoTime - 5);
          break;

        case "m":
        case "M":
          setIsMute((prev) => !prev);
          break;

        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [props.videoControl, props.videoTime, playerRef]);

  // clear if filter changes
  useEffect(() => {
    setCurrentSearchIndex(-1);
    setSearchMatchIndexes([]);
  }, [activeFilter]);
  // search and filter but dont filter out the main array just being used fpor traversal
  useEffect(() => {
    if (!searchStringValue || !filteredData?.length) {
      setSearchMatchIndexes([]);
      setCurrentSearchIndex(-1);
      return;
    }

    const search = searchStringValue.toLowerCase();

    const matches = filteredData.reduce((acc, item, index) => {
      const parts = item.value?.split("-") || [];
      const timestamp = (parts[6] || "").toLowerCase();

      if (
        item.value.toLowerCase().includes(search) ||
        timestamp.includes(search)
      ) {
        acc.push(index);
      }

      return acc;
    }, []);

    setSearchMatchIndexes(matches);
    setCurrentSearchIndex(matches.length ? matches[0] : -1);
  }, [searchStringValue, filteredData]);

  // Track searches once the user pauses typing (debounced), not per keystroke.
  useEffect(() => {
    const q = (searchStringValue || "").trim();
    if (!q) return;
    const t = setTimeout(() => {
      track("tech_qc_search", { query: q, matches: searchMatchIndexes.length });
    }, 800);
    return () => clearTimeout(t);
  }, [searchStringValue, searchMatchIndexes.length, track]);
  // scrollToIndex from <list/> being used
  const goToNextSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    track("tech_qc_search_next");

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const nextPos = (currentPos + 1) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[nextPos]);
  };
  // scrollToIndex from <list/> being used
  const goToPrevSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    track("tech_qc_search_prev");

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const prevPos =
      (currentPos - 1 + searchMatchIndexes.length) % searchMatchIndexes.length;

    setCurrentSearchIndex(searchMatchIndexes[prevPos]);
  };

  const currentAnalyst = matchDetails?.analyst_details?.find((a) => Number(a?.id) === Number(analystId));


  // The match string as currently shown, for comparing with a kept unsaved change.
  const currentMatchString = (transformedStrings ?? []).map((s) => s.value?.trim()).filter(Boolean).join(",");
  const showRecovery =
    !!recoveredSave?.string && !!transformedStrings?.length && recoveredSave.string !== currentMatchString;

  if (isLoading) {
    return (
      <Stack
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "var(--surface-1)",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Typography style={{ color: "var(--text-1)", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Typography>
      </Stack>
    );
  }

  return (
    <div style={{ backgroundColor: "var(--app-bg)", minHeight: "100vh" }}>
      {/* QC Result Modal */}
      {qcResultModal && (
        <div
          onClick={() => setQcResultModal(null)}
          style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: "var(--surface-1)", borderRadius: 16, boxShadow: "0 8px 32px rgba(0,0,0,0.22)", width: 380, padding: "28px 28px 22px", border: "1px solid var(--border-1)" }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", backgroundColor: "#e8f5e9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <FaCheckCircle size={16} color="#2e7d32" />
                </div>
                <span style={{ fontWeight: "700", fontSize: 16, color: "var(--text-1)" }}>Tech QC Complete</span>
              </div>
              <button onClick={() => setQcResultModal(null)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-2)", fontSize: 18, lineHeight: 1, padding: "2px 6px" }}>✕</button>
            </div>
            {[
              { label: "QC Errors", value: qcResultModal.errorCount, bg: "#fdecea", color: "#d32f2f" },
              { label: "Review Errors", value: qcResultModal.reviewErrorCount, bg: "#fdecea", color: "#DA1414" },
              { label: "Warnings", value: qcResultModal.warningCount, bg: "#fff8e1", color: "#f57c00" },
              { label: "No Errors", value: qcResultModal.noErrorsCount, bg: "#e8f5e9", color: "#2e7d32" },
            ].map(({ label, value, bg, color }) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 0", borderBottom: "1px solid var(--border-1)" }}>
                <span style={{ fontSize: 15, color: "var(--text-1)", fontWeight: "500" }}>{label}</span>
                <span style={{ backgroundColor: bg, color, fontWeight: "700", fontSize: 14, padding: "3px 14px", borderRadius: 8, minWidth: 40, textAlign: "center", display: "inline-block" }}>{value}</span>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 14 }}>
              <span style={{ fontSize: 15, color: "var(--text-1)", fontWeight: "700" }}>Total events tag</span>
              <span style={{ backgroundColor: isDarkMode ? "#fff" : "#1a1a1a", color: isDarkMode ? "#1a1a1a" : "#fff", fontWeight: "700", fontSize: 14, padding: "4px 14px", borderRadius: 8, minWidth: 40, textAlign: "center", display: "inline-block" }}>{qcResultModal.total}</span>
            </div>
            <button
              onClick={() => setQcResultModal(null)}
              style={{ marginTop: 22, width: "100%", paddingTop: 14, paddingBottom: 14, backgroundColor: "#FF5A1F", color: "#fff", fontWeight: "700", fontSize: 15, border: "none", borderRadius: 10, cursor: "pointer" }}
            >
              Done
            </button>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, value: "" })}
        onConfirm={confirmDelete}
        title="Delete String"
        isDarkMode={isDarkMode}
        message={
          <>
            Are you sure you want to delete this string?{" "}
            <strong>"{deleteModal.value}"</strong>
          </>
        }
        type="delete"
      />

      {/* Update Confirmation Modal */}
      <ConfirmationModal
        open={updateModal.open}
        onClose={() =>
          setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} })
        }
        onConfirm={confirmUpdate}
        title="Update String"
        isDarkMode={isDarkMode}
        message={
          <>
            Are you sure you want to update this string from{" "}
            <strong>"{updateModal.oldValue}"</strong> to{" "}
            <strong>"{updateModal.newValue?.value}"</strong>?
          </>
        }
        type="update"
      />
      <div style={styles.header.container}>
        <div style={{ ...styles.header.side, width: 180, flexShrink: 0, justifyContent: "flex-start" }}>
          <IconButton
            onClick={() => {
              track("tech_qc_back");
              history.goBack();
            }}
            size="small"
            sx={{
              background: "var(--surface-2)",
              color: "var(--text-1)",
              border: "1px solid var(--border-1)",
              width: 32,
              height: 32,
              "&:hover": { background: "var(--border-1)" },
            }}
          >
            <ArrowBack sx={{ fontSize: 16 }} />
          </IconButton>
        </div>
        <div style={styles.header.center}>
          <span style={styles.header.score}>{matchId}</span>
          <span style={{ color: "var(--border-1)", fontSize: 18, fontWeight: 300 }}>|</span>
          <span style={styles.header.matchInfo}>
            {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
          </span>
        </div>
        <div style={{ ...styles.header.side, width: 180, flexShrink: 0, justifyContent: "flex-end", gap: 8 }}>
          <SaveStatusPill status={isOnline ? saveState.status : "offline"} savedAt={saveState.savedAt} onRetry={flushSaves} />
          <IconButton
            aria-label="toggle theme"
            onClick={toggleMode}
            size="small"
            sx={{ color: "var(--text-2)", borderRadius: "8px", width: 36, height: 36, "&:hover": { backgroundColor: "var(--surface-2)" } }}
          >
            {themeMode === "dark" ? <LightModeOutlined sx={{ fontSize: 20 }} /> : <DarkModeOutlined sx={{ fontSize: 20 }} />}
          </IconButton>
        </div>
      </div>

      {showRecovery && (
        <RecoveryBanner
          savedAt={recoveredSave.at}
          onRestore={() => {
            const strings = recoveredSave.string.split(",").map((v) => v.trim()).filter(Boolean);
            setTransformedStrings(mergeMatchStringsWithErrors(strings, fetchedQcData, null));
            setTimeout(() => cache.current.clearAll(), 0);
            saveMatchString(recoveredSave.string, { reviewOps: recoveredSave.reviewOps ?? [], trigger: "techqc-recovery" });
            track("tech_qc_recover_unsaved", { string_event_count: strings.length });
            setRecoveredSave(null);
          }}
          onDiscard={() => {
            storePendingSave(null);
            track("tech_qc_discard_unsaved");
            setRecoveredSave(null);
          }}
        />
      )}
      <SaveProblemBanner status={saveState.status} error={saveState.error} isOnline={isOnline} onRetry={flushSaves} />

      {/* Info Cards */}
      <div style={styles.cardContainer}>
        {/* Card 1: Teams */}
        <div style={styles.card1.card}>
          <div style={styles.card1.content}>
            <div style={{ ...styles.card1.team, alignItems: "flex-start" }}>
              <div style={styles.card1.label}>Team A</div>
              <div style={styles.card1.teamNameText}>{matchDetails?.team_a_details?.name}</div>
            </div>
            <div style={{ width: 1, height: 36, backgroundColor: "var(--border-1)" }} />
            <div style={{ ...styles.card1.team, alignItems: "flex-end" }}>
              <div style={styles.card1.label}>Team B</div>
              <div style={styles.card1.teamNameText}>{matchDetails?.team_b_details?.name}</div>
            </div>
          </div>
        </div>

        {/* Card 2: Analyst + reviewers */}
        <div style={styles.card2.card}>
          <div style={styles.card2.content}>
            <div style={styles.card2.box}>
              <div style={styles.card2.id}>{currentAnalyst?.id}</div>
            </div>
            <div style={styles.card2.textRight}>
              <div style={styles.card2.name}>{currentAnalyst?.name}</div>
              <div style={styles.card2.label}>Analyst ID & Name</div>
            </div>
            <div style={styles.card2.divider} />
            <ReviewerFeedbackPanel
              reviewers={matchDetails?.reviewer_details ?? []}
              summaries={reviewStrings?.reviewers ?? []}
              inString={reviewerCountsInString}
              loading={reviewStringsLoading}
              failed={reviewStringsFailed}
            />
          </div>
        </div>

        {/* Card 3: Elapsed time */}
        <div style={styles.card3.card}>
          <div style={styles.card3.row}>
            <div style={styles.card3.title}>Elapsed time</div>
            <div style={styles.card3.time}>
              {formatTimeFromSeconds(details.analysis_tat) || "00:00:00"}
            </div>
          </div>
        </div>
          <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={1.5}
                  onClick={() => history.push(`/match-details/${matchDetails?.id}`)}
                  sx={{
                    flex: "1 1 150px",
                    minWidth: 0,
                    height: 72,
                    boxSizing: "border-box",
                    px: 1.5,
                    backgroundColor: "var(--surface-1)",
                    border: "1px solid var(--border-1)",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                    "&:hover": { borderColor: "rgba(232,108,0,0.5)", boxShadow: "0 4px 12px rgba(232,108,0,0.12)" },
                  }}
                >
                  <Stack>
                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>Match Details</Typography>
                    <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "var(--text-1)", mt: 0.25, whiteSpace: "nowrap" }}>View full details</Typography>
                  </Stack>
                  <Stack sx={{ width: 28, height: 28, borderRadius: "8px", backgroundColor: "rgba(232,108,0,0.12)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <OpenInNew sx={{ fontSize: 15, color: "rgba(232,108,0,1)" }} />
                  </Stack>
                </Stack>
          <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={1.5}
                  onClick={() => setLineupPopupOpen(true)}
                  sx={{
                    flex: "1 1 150px",
                    minWidth: 0,
                    height: 72,
                    boxSizing: "border-box",
                    px: 1.5,
                    backgroundColor: "var(--surface-1)",
                    border: "1px solid var(--border-1)",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                    "&:hover": { borderColor: "rgba(232,108,0,0.5)", boxShadow: "0 4px 12px rgba(232,108,0,0.12)" },
                  }}
                >
                  <Stack>
                    <Typography sx={{ fontSize: "10px", fontWeight: 600, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>Line Up</Typography>
                    <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "var(--text-1)", mt: 0.25, whiteSpace: "nowrap" }}>Quick view</Typography>
                  </Stack>
                  <Stack sx={{ width: 28, height: 28, borderRadius: "8px", backgroundColor: "rgba(232,108,0,0.12)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Groups sx={{ fontSize: 15, color: "rgba(232,108,0,1)" }} />
                  </Stack>
                </Stack>
      </div>

      <LineupPopup
        open={lineupPopupOpen}
        onClose={() => setLineupPopupOpen(false)}
        matchId={matchDetails?.id}
        token={token}
      />

      <div style={styles.urlCard.wrapper}>
        {showUrlInput ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <input
              type="text"
              autoFocus
              placeholder="Paste video URL..."
              value={urlInput}
              onChange={(e) => setUrlInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && urlInput.trim()) { props.LoadVideoUrl(urlInput.trim()); setShowUrlInput(false); } if (e.key === "Escape") setShowUrlInput(false); }}
              style={{ flex: 1, padding: "8px 12px", border: "1px solid var(--border-1)", borderRadius: 8, outline: "none", fontSize: 13, backgroundColor: "var(--surface-2)", color: "var(--text-1)" }}
            />
            <button onClick={() => { if (urlInput.trim()) { props.LoadVideoUrl(urlInput.trim()); setShowUrlInput(false); } }} style={{ backgroundColor: "#FF5A1F", border: "none", padding: "8px 16px", borderRadius: 8, color: "#fff", fontWeight: "600", fontSize: 13, cursor: "pointer" }}>Load</button>
            <button onClick={() => setShowUrlInput(false)} style={{ background: "none", border: "1px solid var(--border-1)", padding: "8px 12px", borderRadius: 8, color: "var(--text-2)", fontSize: 13, cursor: "pointer" }}>Cancel</button>
          </div>
        ) : (
          <div style={styles.urlCard.row}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, minWidth: 0, overflow: "hidden" }}>
              <FaLink size={13} color="var(--text-2)" style={{ flexShrink: 0 }} />
              <span style={{ fontSize: 12, color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {props.videoUrl || matchDetails?.youtube_videos?.[0]?.url || "No video loaded"}
              </span>
            </div>
            <button onClick={() => setShowUrlInput(true)} style={{ background: "none", border: "1px solid var(--border-1)", padding: "5px 14px", borderRadius: 6, color: "var(--text-2)", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap", fontWeight: "500" }}>Load URL</button>
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "12px",
          margin: "0 20px 20px 20px",
        }}
      >
        <div style={{ flex: "0 0 58%", minWidth: 0 }}>
          <div style={{ width: "100%" }}>
            <Stack style={styles.videoContainer}>
              {props.videoUrl || matchDetails?.youtube_videos[0]?.url ? (
                <VideoPlayer
                  cref={playerRef}
                  url={props.videoUrl || matchDetails?.youtube_videos[0]?.url}
                  controls={showControls}
                  played={props.videoTime}
                  muted={isMute}
                  onProgress={(e) => {
                    !seeking && UpdateVideoTime(e);
                  }}
                  //    setElapsedTime={this.setElapsedTime}
                  playing={props.videoControl}
                  onPause={() => {
                    SetVideoControl(false);
                  }}
                  onEnded={() => {
                    SetVideoControl(false);
                  }}
                  onPlay={() => {
                    SetVideoControl(true);
                  }}
                  onReady={() => {
                    setReady(true);
                  }}
                  playbackRate={speed}
                  onDuration={(t) => {
                    setDuration(t);
                  }}
                />
              ) : (
                <Stack
                  style={{
                    height: "60vh",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontSize: 16, color: "#FF5A1F" }}>
                    Video URL Not Found.
                  </Typography>
                </Stack>
              )}

              {ready && !isYoutubeUrl() && (
                <Stack style={styles.videoTimeline}>
                  <input
                    type="range"
                    value={props.videoTime}
                    style={{ width: "100%", borderWidth: 0 }}
                    min={0}
                    max={duration}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </Stack>
              )}

              {ready && (
                <Stack style={styles.controlContainer}>
                  {/* Left: Jump To + timestamp */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 5 }}>
                    <FaStopwatch size={11} color="var(--text-2)" />
                    <TextInput
                      style={{
                        width: "5.5rem", fontSize: "11px",
                        border: "1px solid var(--border-1)", borderRadius: "5px",
                        backgroundColor: "var(--surface-2)", color: "var(--text-1)",
                        paddingVertical: "5px", paddingHorizontal: "6px",
                        outline: "none", textAlign: "center",
                      }}
                      onChangeText={setJumpTo}
                      defaultValue={jumpTo}
                      placeholder="HH:MM:SS"
                    />
                    <TouchableOpacity
                      disabled={jumpTo === ""}
                      onPress={() => jumpManually(jumpTo)}
                      style={{
                        width: 26, height: 26, borderRadius: 5,
                        justifyContent: "center", alignItems: "center",
                        backgroundColor: jumpTo ? "#FF5A1F" : "var(--surface-2)",
                        border: "1px solid var(--border-1)",
                      }}
                    >
                      <FaArrowRight size={9} color={jumpTo ? "#fff" : "var(--text-2)"} />
                    </TouchableOpacity>
                    {!isYoutubeUrl() && (
                      <>
                        <div style={{ width: 1, height: 18, background: "var(--border-1)", margin: "0 4px" }} />
                        <Duration seconds={props.videoTime} />
                      </>
                    )}
                  </div>

                  {/* Center: Play/Pause */}
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {!isYoutubeUrl() && (
                      <TouchableOpacity
                        onPress={() => { track("tech_qc_video_playpause", { playing: !props.videoControl, source: "button" });
                            props.SetVideoControl(!props.videoControl); }}
                        style={{
                          flexDirection: "row", alignItems: "center", gap: 6,
                          backgroundColor: "#FF5A1F",
                          paddingHorizontal: "14px", paddingVertical: "6px",
                          borderRadius: "7px",
                        }}
                      >
                        {!props.videoControl ? <FaPlay color="#fff" size={10} /> : <FaPause color="#fff" size={10} />}
                        <Typography style={{ fontSize: "12px", color: "#fff", fontWeight: "600" }}>
                          {!props.videoControl ? "Play" : "Pause"}
                        </Typography>
                      </TouchableOpacity>
                    )}
                  </div>

                  {/* Right: Speed pills + icons */}
                  <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                    {!isYoutubeUrl() && (
                      <div style={{ display: "flex", border: "1px solid var(--border-1)", borderRadius: 6, overflow: "hidden" }}>
                        {[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75].map((s, i) => (
                          <TouchableOpacity
                            key={s}
                            onPress={() => setSpeed(s)}
                            style={{
                              paddingHorizontal: "8px", paddingVertical: "5px",
                              backgroundColor: speed === s ? "#FF5A1F" : "var(--surface-2)",
                              borderRight: i < 6 ? "1px solid var(--border-1)" : "none",
                              alignItems: "center", justifyContent: "center",
                            }}
                          >
                            <Typography style={{ fontSize: "10px", fontWeight: "600", color: speed === s ? "#fff" : "var(--text-2)" }}>
                              {s}x
                            </Typography>
                          </TouchableOpacity>
                        ))}
                      </div>
                    )}
                    <TouchableOpacity
                      onPress={full}
                      style={{ width: 28, height: 28, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      <AiOutlineFullscreen color="var(--text-1)" size={14} />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={handleMute}
                      style={{ width: 28, height: 28, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      {isMute ? <IoMdVolumeOff color="var(--text-1)" size={14} /> : <IoMdVolumeHigh color="var(--text-1)" size={14} />}
                    </TouchableOpacity>
                  </div>
                </Stack>
              )}
            </Stack>
            <div style={{ marginTop: 10, display: "flex", borderRadius: 10, border: "1px solid var(--border-1)", flexDirection: "row", alignItems: "stretch", overflow: "hidden", backgroundColor: "var(--surface-1)" }}>
              {/* Event Details */}
              <div style={{ borderRight: "1px solid var(--border-1)", padding: "12px 14px", width: "33%" }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>Event Details</div>
                <InfoRow label="QC Errors" value={initialEventDetails?.error || 0} bgColor="#fdecea" textColor="#d32f2f" />
                <InfoRow label="Review Errors" value={initialEventDetails?.reviewError || 0} bgColor="#fdecea" textColor="#DA1414" />
                <InfoRow label="Warnings" value={initialEventDetails?.warning || 0} bgColor="#fff4cc" textColor="#f57c00" />
                <InfoRow label="No Errors" value={initialEventDetails?.noIssue || 0} bgColor="#e6f4ea" textColor="#2e7d32" />
                <InfoRow label="Total events tag" value={initialEventDetails.total || 0} bgColor="#333" textColor="#fff" bold />
                <div style={{ marginTop: 6, fontSize: 11, color: "#E02424", lineHeight: "1.5" }}>Resolve all errors and warnings before submitting.</div>
              </div>

              {/* QC Status */}
              <div style={{ borderRight: "1px solid var(--border-1)", padding: "12px 14px", width: "33%" }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>QC Status</div>
                <InfoRow label="Active Errors" value={errorCount || 0} bgColor="#fdecea" textColor="#d32f2f" />
                <InfoRow label="Active Warnings" value={warningCount || 0} bgColor="#fff4cc" textColor="#f57c00" />
                <InfoRow label="No Errors" value={noErrorsCount || 0} bgColor="#e6f4ea" textColor="#2e7d32" />
                <InfoRow label="Active Review Errors" value={reviewErrorCount || 0} bgColor="#fdecea" textColor="#DA1414" />
                <InfoRow label="Issues Fixed" value={Math.max((initialEventDetails.warning || 0) + (initialEventDetails.error || 0) + (initialEventDetails.reviewError || 0) - (errorCount + warningCount + reviewErrorCount), 0) || 0} bgColor="#e3f2fd" textColor="#1976d2" />
                <InfoRow label="Total events tag" value={transformedStrings?.length || 0} bgColor="#333" textColor="#fff" bold />
              </div>

              {/* Actions */}
              <div style={{ padding: "12px 14px", width: "33%", display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ fontSize: 11, fontWeight: "700", marginBottom: 0, textTransform: "uppercase", letterSpacing: "0.06em", color: "var(--text-2)" }}>Actions</div>
                <button
                  style={{ backgroundColor: "#FF5A1F", paddingTop: 18, paddingBottom: 18, paddingLeft: 0, paddingRight: 0, borderRadius: 8, border: "none", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", opacity: transformedStrings?.length === undefined || isRunningQC ? 0.5 : 1, cursor: transformedStrings?.length === undefined || isRunningQC ? "not-allowed" : "pointer" }}
                  disabled={transformedStrings?.length === undefined || isRunningQC}
                  onClick={runTechQCManually}
                >
                  <span style={{ color: "#fff", fontWeight: "700", fontSize: 15, display: "flex", alignItems: "center", gap: 7 }}>
                    {isRunningQC ? <CircularProgress size={16} thickness={4} color="inherit" sx={{ color: "#fff" }} /> : <><FaSyncAlt size={14} /> Run Tech QC</>}
                  </span>
                </button>
                <button
                  style={{ backgroundColor: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "var(--surface-2)" : "#007D48", paddingTop: 18, paddingBottom: 18, paddingLeft: 0, paddingRight: 0, borderRadius: 8, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", border: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "1px solid var(--border-1)" : "none", opacity: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? 0.5 : 1, cursor: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? "not-allowed" : "pointer" }}
                  disabled={isSubmitting || errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined}
                  onClick={handleSubmitFinalQC}
                >
                  <span style={{ color: errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 ? "var(--text-2)" : "#fff", fontWeight: "700", fontSize: 15, display: "flex", alignItems: "center", gap: 7 }}>
                    {isSubmitting ? <CircularProgress size={16} thickness={4} sx={{ color: "#fff" }} /> : <>Mark Analysis Done <FaArrowRight size={13} /></>}
                  </span>
                </button>
                {errorCount > 0 || warningCount > 0 || reviewErrorCount > 0 || transformedStrings?.length === undefined ? (
                  <div style={{ fontSize: 11, color: "#E02424", lineHeight: "1.5" }}>Resolve all errors and warnings before submitting.</div>
                ) : (
                  <div style={{ fontSize: 11, color: "#2e7d32" }}>✓ All issues addressed. Ready to submit.</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 42%",
            overflow: "hidden",
            borderRadius: 10,
            backgroundColor: "var(--surface-1)",
            color: "var(--text-1)",
            border: "1px solid var(--border-1)",
            position: "relative",
          }}
        >
          {(!isOnline || saveState.status === "failed") && (
            <EditingPausedOverlay isOnline={isOnline} onRetry={flushSaves} />
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",

              margin: "1rem 1rem 0rem 1rem",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <FilterButtons
                active={activeFilter}
                setActive={(v) => { track("tech_qc_filter", { filter: v }); setActiveFilter(v); }}
              />
              {activeFilter === "review_error" && (matchDetails?.reviewer_details?.length ?? 0) > 0 && (
                <select
                  aria-label="Filter review errors by reviewer"
                  value={reviewerFilter}
                  onChange={(e) => {
                    track("tech_qc_reviewer_filter", { reviewer_id: e.target.value });
                    setReviewerFilter(e.target.value);
                  }}
                  style={{ marginLeft: 8, height: 28, maxWidth: 200, flexShrink: 0, borderRadius: 6, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-2)", color: "var(--text-1)", fontSize: 12, padding: "0 6px" }}
                >
                  <option value="all">All reviewers ({reviewErrorCount || 0})</option>
                  {matchDetails.reviewer_details.map((r) => (
                    <option key={r.id} value={String(r.id)}>
                      {(r.name || r.username || "Unnamed")} · {r.id} ({reviewerCountsInString.get(String(r.id))?.open ?? 0})
                    </option>
                  ))}
                </select>
              )}
              <div style={{ display: "flex", gap: 6, flexShrink: 0, marginLeft: 8 }}>
                <button
                  title="Go to Top"
                  onClick={() => listRef.current?.scrollToPosition(0)}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(90deg)" }} size={10} /> Top
                </button>
                <button
                  title="Go to Bottom"
                  onClick={() => listRef.current?.scrollToRow(filteredData.length - 1)}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(270deg)" }} size={10} /> Bottom
                </button>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                margin: "10px",
                alignItems: "center",
              }}
            >
              {/* Search Box */}
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "var(--surface-2)",
                  borderRadius: 6,
                  padding: "8px 12px",
                  border: "1px solid var(--border-1)",
                }}
              >
                <FaSearch color="var(--text-2)" size={14} />
                <input
                  value={searchStringValue}
                  onChange={(e) => setSearchStringValue(e.target.value)}
                  placeholder="Search String by Timestamp"
                  style={{
                    flex: 1,
                    marginLeft: 8,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 13,
                    color: "var(--text-1)",
                  }}
                />
                {searchStringValue && searchMatchIndexes.length > 0 && (
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        paddingRight: "6px",
                        borderRight: "1px solid var(--border-1)",
                        color: "var(--text-2)",
                      }}
                    >
                      {searchMatchIndexes.indexOf(currentSearchIndex) + 1} /{" "}
                      {searchMatchIndexes.length}
                    </Typography>

                    <FaAngleUp
                      onClick={goToNextSearchMatch}
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                    />

                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                      onClick={goToPrevSearchMatch}
                    />
                    <FaTimes
                      size={16}
                      color="#6B7280"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchStringValue("");
                        if (listRef.current) {
                          listRef.current.scrollToPosition(scrollPosition);
                          // listRef.current.recomputeRowHeights(index);
                        }
                      }}
                    />
                  </Stack>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                }}
              >
                {/* Prev Error Button */}
                <button
                  disabled={Boolean(searchStringValue.length)}
                  onClick={goToPrevError}
                  style={{
                    flex: 1,
                    cursor: Boolean(searchStringValue.length) ? "not-allowed" : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.5 : 1,
                    paddingTop: 11, paddingBottom: 11,
                    borderRadius: 8,
                    backgroundColor: "var(--surface-1)",
                    border: "1px solid var(--border-1)",
                    fontWeight: 600,
                    fontSize: 13,
                    color: "var(--text-1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaArrowLeft size={11} /> Prev Error
                </button>

                {/* Next Error Button */}
                <button
                  disabled={Boolean(searchStringValue.length)}
                  onClick={goToNextError}
                  style={{
                    flex: 1,
                    cursor: Boolean(searchStringValue.length) ? "not-allowed" : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.5 : 1,
                    paddingTop: 11, paddingBottom: 11,
                    borderRadius: 8,
                    backgroundColor: "#FF5A1F",
                    color: "#fff",
                    border: "none",
                    fontWeight: 600,
                    fontSize: 13,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 7,
                    whiteSpace: "nowrap",
                  }}
                >
                  Next Error <FaArrowRight size={11} />
                </button>

                <LegendTooltipIcon />
              </div>
            </div>
          </div>
          {transformedStrings && transformedStrings.length > 0 ? (
            <div style={{ height: "87%", backgroundColor: "var(--surface-1)" }}>
              {filteredData.length > 0 ? (
                <AutoSizer>
                  {({ width, height }) => {
                    return (
                      <List
                        ref={listRef}
                        scrollToAlignment="start"
                        style={{
                          padding: "10px",
                          marginTop: "0.6rem",
                          paddingBottom: "2rem",
                          backgroundColor: "var(--surface-1)",
                        }}
                        onScroll={({ scrollTop }) => {
                          setScrollPosition(scrollTop);
                        }}
                        width={width}
                        height={height}
                        deferredMeasurementCache={cache.current}
                        rowCount={filteredData.length}
                        scrollToIndex={
                          searchStringValue && currentSearchIndex !== -1
                            ? currentSearchIndex
                            : currentErrorGlobalIndex != null &&
                              !skipScrollToIndex
                            ? currentErrorGlobalIndex
                            : undefined
                        }
                        rowHeight={cache.current.rowHeight}
                        rowRenderer={({ index, key, style, parent }) => {
                          const item = filteredData[index];
                          return (
                            <CellMeasurer
                              key={key}
                              cache={cache.current}
                              parent={parent}
                              columnIndex={0}
                              rowIndex={index}
                            >
                              <div style={style}>
                                <EditableTag
                                  key={item.id}
                                  refetch={refetchReviewerStrings}
                                  errorIndex={currentErrorGlobalIndex}
                                  activeFilter={activeFilter}
                                  index={index}
                                  lineNumber={lineNumberMap.get(item.id ?? item.value)}
                                  analystId={analystId}
                                  token={token}
                                  track={track}
                                  searchValue={searchStringValue}
                                  matchId={matchId}
                                  reviewerId={reviewerId}
                                  text={item.value}
                                  type={item.type}
                                  message={item.message}
                                  ignored={item.ignored}
                                  reviewStatus={item.reviewStatus}
                                  reviewComments={item.reviewComments}
                                  reviewEntries={item.reviewEntries}
                                  onChange={(newVal) => {
                                    // cache.current.clear(index);
                                    updateTag(item.id, newVal);
                                  }}
                                  onAddNewtag={() => {
                                    // cache.current.clear(index);
                                    addTag(item.id);
                                  }}
                                  onDelete={() => {
                                    // cache.current.clear(index);
                                    deleteStringByIndex(item.id);
                                  }}
                                  jumpManually={jumpManually}
                                  isDarkMode={isDarkMode}
                                />
                              </div>
                            </CellMeasurer>
                          );
                        }}
                      />
                    );
                  }}
                </AutoSizer>
              ) : (
                <Stack
                  style={{
                    padding: 16,
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Typography style={{ color: "gray", fontSize: 16 }}>
                    {`No ${activeFilter} strings found`}
                  </Typography>
                </Stack>
              )}
            </div>
          ) : IsInitialQC ? (
            <Stack
              style={{
                flex: 1,
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
              }}
            >
              <Stack style={{ alignItems: "center" }}>
                <CircularProgress
                  sx={{
                    color: "#F96302",
                  }}
                />
                <Typography
                  style={{ color: "gray", fontSize: 16, marginTop: 12 }}
                >
                  Loading QC Data
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <Stack
              style={{
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "-webkit-fill-available",
                height: "60vh",
              }}
            >
              <Typography style={{ color: "gray", fontSize: 16 }}>
                No strings available
              </Typography>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
};

// Assigned reviewers and whether each has given feedback on this match.
// Sized for the fixed-height analyst card: scrolls when there are many reviewers.
const ReviewerFeedbackPanel = ({ reviewers, summaries, inString, loading, failed }) => {
  const summaryFor = (id) => summaries.find((s) => String(s.reviewerId) === String(id));

  const statusFor = (reviewer) => {
    if (failed) return { text: "Couldn't load", title: "Couldn't load reviewer feedback", color: "#d32f2f" };
    if (loading) return { text: "Loading…", title: "Loading reviewer feedback", color: "var(--text-2)" };
    const summary = summaryFor(reviewer.id);
    if (summary?.failed) {
      return {
        text: "Couldn't load",
        title: "This reviewer's feedback couldn't be loaded, so their errors aren't shown. The others' feedback is shown.",
        color: "#d32f2f",
      };
    }
    if (!summary || summary.total === 0) {
      return { text: "No feedback yet", title: "This reviewer hasn't marked any events yet", color: "var(--text-2)" };
    }
    // Counted on the current string so they match the list and filter; open
    // errors left on events since edited or deleted are shown separately.
    const { checked, open } = inString.get(String(reviewer.id)) ?? { checked: 0, open: 0 };
    const removedOpen = Math.max(summary.openErrors - open, 0);
    return {
      text:
        `${checked} checked · ${open} open error${open === 1 ? "" : "s"}` +
        (removedOpen > 0 ? ` · +${removedOpen} on removed` : ""),
      title:
        `${checked} events in the current string have feedback from this reviewer ` +
        `(reviewed, error, fixed or ignored); ${open} of them are errors not yet fixed.` +
        (removedOpen > 0
          ? ` ${removedOpen} more open errors are on events no longer in the string (edited or deleted).`
          : ""),
      color: open > 0 ? "#DA1414" : removedOpen > 0 ? "#d97706" : "#2e7d32",
    };
  };

  return (
    <div style={styles.card2.reviewers}>
      <div style={styles.card2.label}>Reviewer's Feedback</div>
      {reviewers.length === 0 ? (
        <div style={styles.card2.reviewerRow}>
          <span style={{ color: "var(--text-2)" }}>None assigned</span>
        </div>
      ) : (
        reviewers.map((reviewer) => {
          const status = statusFor(reviewer);
          const name = reviewer.name || reviewer.username || "Unnamed";
          return (
            <div key={reviewer.id} style={styles.card2.reviewerRow} title={`${name} (ID ${reviewer.id}) — ${status.title}`}>
              <span style={styles.card2.reviewerName}>
                {name}
                <span style={{ color: "var(--text-2)", fontWeight: 400 }}> · {reviewer.id}</span>
              </span>
              <span style={{ fontWeight: 600, color: status.color, flexShrink: 0 }}>{status.text}</span>
            </div>
          );
        })
      )}
    </div>
  );
};

const InfoRow = ({ label, value, bgColor, textColor, bold }) => {
  const isDark = document.body.classList.contains("theme-dark");
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "5px 0",
      borderBottom: "1px solid var(--border-1)",
    }}>
      <span style={{ fontSize: 13, color: "var(--text-1)", fontWeight: bold ? "700" : "400" }}>
        {label}
      </span>
      <span style={{
        backgroundColor: isDark ? "transparent" : bgColor,
        padding: "2px 8px",
        borderRadius: 5,
        border: `1px solid ${isDark ? "var(--border-1)" : bgColor}`,
        color: textColor,
        fontWeight: "700",
        fontSize: 12,
        minWidth: 32,
        textAlign: "center",
        display: "inline-block",
      }}>
        {value}
      </span>
    </div>
  );
};

const EditableTag = ({
  text,
  activeFilter,
  ignored,
  errorIndex,
  onChange,
  index,
  lineNumber,
  message,
  onAddNewtag,
  onDelete,
  type = "noIssue",
  jumpManually,
  analystId,
  searchValue,
  token,
  matchId,
  refetch,
  reviewerId,
  reviewStatus,
  reviewComments,
  reviewEntries,
  isDarkMode,
  track = () => {},
}) => {
  const reviewItem = { reviewEntries, reviewStatus, reviewComments };

  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);

  const getEventFromString = (str) => {
    const parts = str?.split("-");
    if (parts?.length < 3) return null;
    const eventCode = `${parts?.[2]}-${parts?.[3]}`;
    return EVENT_MAP[eventCode] || null;
  };

  useEffect(() => {
    setValue(text);
  }, [text]);

  const handleIgnoredStrings = async () => {
    track("tech_qc_mark_ignored", { string: value });
    try {
      await Promise.all(
        reviewRowsFor(reviewItem, reviewerId).map((row) =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: row.reviewer_id,
              string_details: [
                {
                  string: value,
                  string_status: 3,
                  comments: message || "",
                },
              ],
            },
          })
        )
      );

      toast.success("Marked as Ignored");

      // Refetch so reviewStringMap has the updated string_status: 3
      await refetch();

      // Update UI immediately
      onChange({
        value,
        type: "ignored",
        message,
        ignored: true,
        reviewStatus: 3,
        reviewComments: message,
      });
    } catch (err) {
      console.error("Failed to ignore string:", err);
      toast.error("Failed to mark as ignored");
    }
  };

  const highlightText = (text, search) => {
    if (!search) return text;

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "ig");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#FFE58F",
            padding: "0 2px",
            borderRadius: 3,
            fontWeight: 600,
          }}
        >
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const handleMarkedAsFixed = async () => {
    track("tech_qc_mark_fixed", { string: value });
    try {
      // remove old value update wih new
      await Promise.all(
        reviewRowsFor(reviewItem, reviewerId).map((row) =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: row.reviewer_id,
              string_details: [
                // {
                //   string: value,
                //   string_status: reviewStatus,
                //   comments: reviewComments,
                //   delete: true,
                // },
                {
                  string: value,
                  string_status: 1,
                  comments: row.comments,
                },
              ],
            },
          })
        )
      );

      await refetch();
      toast.success("Marked as fixed");

      //update ui
      onChange({
        value,
        type: "fixed",
        message: "Issue resolved",
        ignored: false,
        reviewStatus: 1,
        reviewComments,
      });
    } catch (err) {
      console.error("Failed to fix review error:", err);
      toast.error("Failed to mark as fixed");
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    onChange({
      value,
      type,
      message,
      ignored,
      reviewStatus,
      reviewComments,
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return { text: "Pending", color: "#f57c00", bgColor: "#fff4cc" };
      case 1:
        return { text: "Approved", color: "#2e7d32", bgColor: "#e6f4ea" };
      case 2:
        return { text: "Rejected", color: "#d32f2f", bgColor: "#fdecea" };
      default:
        return { text: "N/A", color: "#666", bgColor: "#f5f5f5" };
    }
  };

  const getStyleByType = (type, stringValue) => {
    const eventData = getEventFromString(stringValue);
    
    // Helper to darken background for dark mode
    const adjustBg = (color) => isDarkMode ? `${color}40` : color;
    const adjustText = (color) => isDarkMode ? "#ffffff" : "#000000";

    switch (type) {
      case "error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
          textColor: isDarkMode ? "#ff8a8a" : "#DA1414",
          iconColor: "#DA1414",
          badgeColor: isDarkMode ? "#451010" : "#f6e3e3ff",
          status: "Error",
        };
      case "review_error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
          textColor: isDarkMode ? "#ff8a8a" : "#DA1414",
          iconColor: "#DA1414",
          badgeColor: isDarkMode ? "#451010" : "#f6e3e3ff",
          status: "Review Error",
        };
      case "warning":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#B95000",
          backgroundColor: isDarkMode ? "#452a10" : "#FFF4EC",
          textColor: isDarkMode ? "#ffb37a" : "#B95000",
          badgeColor: isDarkMode ? "#452a10" : "#f7e9ddff",
          iconColor: "#B95000",
          status: "Warning",
        };
      case "fixed":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          badgeColor: isDarkMode ? "#102a45" : "#bad9faff",
          status: "Fixed",
          borderColor: "#1A56DB",
          backgroundColor: isDarkMode ? "#102a45" : "#E1EFFE",
          textColor: adjustText("#1A56DB"),
          iconColor: "#1A56DB",
        };
      case "ignored":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          iconColor: "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          status: "Ignored",
        };
      case "noIssue":
      default:
        if (eventData) {
          return {
            statusIcon: FaCheckCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            status: "No issue",
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          iconColor: "#287D3C",
          status: "No issue",
        };
    }
  };

  const {
    borderColor,
    statusIcon,
    backgroundColor,
    badgeColor,
    textColor,
    iconColor,
    status,
  } = getStyleByType(type, value);

  const reduceTimeBySeconds = (timeString, secondsToReduce) => {
    const [hh, mm, rest] = timeString.split(":");
    const [ss, ms = "0"] = rest.split(".");

    const hours = parseInt(hh, 10);
    const minutes = parseInt(mm, 10);
    const seconds = parseInt(ss, 10);
    const milliseconds = parseInt(ms.padEnd(3, "0"), 10);

    let totalMs = (hours * 3600 + minutes * 60 + seconds) * 1000 + milliseconds;
    totalMs -= secondsToReduce * 1000;

    if (totalMs < 0) totalMs = 0;

    const newHours = Math.floor(totalMs / 3600000);
    const newMinutes = Math.floor((totalMs % 3600000) / 60000);
    const newSeconds = Math.floor((totalMs % 60000) / 1000);
    const newMs = totalMs % 1000;

    return `${newHours.toString().padStart(2, "0")}:${newMinutes
      .toString()
      .padStart(2, "0")}:${newSeconds.toString().padStart(2, "0")}.${newMs
      .toString()
      .padStart(3, "0")}`;
  };

  const jumpManuallyViaString = () => {
    const timeStr = value.split("-")[6];
    const newTimeStr = reduceTimeBySeconds(timeStr, 2);
    jumpManually(newTimeStr);
  };

  const statusInfo = getStatusLabel(reviewStatus);

  return (
    <Stack>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          alignItems: "center",
          width: "100%",
          marginBottom: "5px",
          justifyContent: "center",
        }}
      >
        {lineNumber != null && (
          <span style={{ fontSize: 10, color: "var(--text-2)", fontWeight: "600", minWidth: 28, textAlign: "right", flexShrink: 0, userSelect: "none", letterSpacing: "0.02em" }}>
            {lineNumber}
          </span>
        )}
        <Stack
          sx={{
            backgroundColor,
            borderRadius: "8px",
            paddingX: "12px",
            paddingY: "10px",
            border: `1px solid ${borderColor}`,
            borderWidth: "1px",
            borderColor,
            marginBottom: "1px",
            minHeight: "30px",
            width: lineNumber != null ? "calc(90% - 33px)" : "90%",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity activeOpacity={1} style={{ flex: 1 }}>
            {isEditing ? (
              <TextInput
                autoFocus
                value={value}
                onChangeText={setValue}
                onBlur={handleBlur}
                style={{
                  fontSize: 14,
                  color: isDarkMode ? "white" : "black",
                  backgroundColor: isDarkMode ? "var(--surface-2)" : "#fff",
                  accentColor: "white",
                  outline: "none",
                  padding: 3,
                  borderRadius: 4,
                }}
              />
            ) : (
              <Typography
                style={{
                  fontSize: 14,
                  color: textColor,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                {React.createElement(statusIcon, { color: iconColor })}
                <span>{highlightText(value, searchValue)}</span>
              </Typography>
            )}
          </TouchableOpacity>

          <Stack
            style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
          >
            {isEditing && (
              <TouchableOpacity
                onPress={handleBlur}
                style={{
                  marginLeft: "1rem",
                }}
              >
                <FaCheck color={iconColor} />
              </TouchableOpacity>
            )}
            <TouchableOpacity onPress={jumpManuallyViaString}>
              <FaVideo color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => setIsEditing(true)}>
              <FaEdit color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={onDelete}>
              <FaTrashAlt color="#DA1414" />
            </TouchableOpacity>

            {type === "warning" ? (
              <TouchableOpacity
                style={{
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 4,
                  borderWidth: 1,
                  borderColor: iconColor,
                  marginLeft: 6,
                }}
                onPress={handleIgnoredStrings}
              >
                <Typography style={{ color: iconColor, fontSize: 12 }}>
                  Mark as Ignored
                </Typography>
              </TouchableOpacity>
            ) : type === "review_error" ? (
              <TouchableOpacity
                style={{
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 4,
                  borderWidth: 1,
                  backgroundColor: badgeColor,
                  borderColor: borderColor,
                  marginLeft: 6,
                }}
                onPress={handleMarkedAsFixed}
              >
                <Typography style={{ color: textColor, fontSize: 12 }}>
                  Mark as Fixed
                </Typography>
              </TouchableOpacity>
            ) : (
              <Typography
                style={{
                  color: iconColor,
                  borderRadius: "5px",
                  marginLeft: 8,
                  backgroundColor: badgeColor,
                  padding: "0.2rem",
                  fontSize: 12,
                }}
              >
                {status}
              </Typography>
            )}
          </Stack>
        </Stack>
        {activeFilter === "all" && (
          <TouchableOpacity
            style={{
              color: "white",
              backgroundColor: "#FF5A1F",
              borderRadius: "8px",
              padding: "12px",
            }}
            onPress={() => onAddNewtag(index)}
          >
            <FaPlus />
          </TouchableOpacity>
        )}
      </Stack>
      {(type === "warning" || type === "error" || type === "review_error") && message ? (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          {lineNumber != null && <div style={{ minWidth: 33, flexShrink: 0 }} />}
          <Typography
            style={{
              padding: "6px 10px",
              width: lineNumber != null ? "calc(90% - 33px)" : "90%",
              marginBottom: 4,
              fontSize: 12,
              borderRadius: "8px",
              ...(type === "warning" ? {
                backgroundColor: isDarkMode ? "#452a10" : "#FFF4EC",
                color: isDarkMode ? "#ffb37a" : "#B95000",
              } : type === "review_error" ? {
                border: isDarkMode ? "1px solid #374151" : "1px solid #DA1414",
                backgroundColor: isDarkMode ? "#000" : "#fdecea",
                color: isDarkMode ? "#fff" : "#DA1414",
              } : {
                backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
                color: isDarkMode ? "#ff8a8a" : "#DA1414",
              }),
            }}
          >
            {type === "warning" ? "Warning! " : type === "review_error" ? "Review Error! " : "Error! "}{message}
          </Typography>
        </div>
      ) : null}
    </Stack>
  );
};

const FilterButtons = ({ active, setActive }) => {
  const filters = [
    { label: "All", value: "all" },
    { label: "Errors", value: "error" },
    { label: "Review Errors", value: "review_error" },
    { label: "Warnings", value: "warning" },
    { label: "Ignored", value: "ignored" },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        marginTop: 8,
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 8,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {filters.map(({ label, value }) => {
        const isActive = active === value;

        return (
          <button
            key={value}
            type="button"
            onClick={() => setActive(value)}
            style={{
              backgroundColor: isActive ? "#FF5A1F" : "var(--surface-2)",
              borderRadius: 6,
              flex: "0 0 auto",
              padding: "0 10px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: isActive ? "none" : "1px solid var(--border-1)",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                color: isActive ? "#fff" : "var(--text-1)",
                fontSize: 12,
                fontWeight: "500",
              }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const LegendTooltipIcon = () => {
  const grouped = {
    passing: [],
    shooting: [],
    defending: [],
    goalkeeping: [],
  };

  Object.entries(EVENT_MAP).forEach(([key, val]) => {
    grouped[val.group].push({ code: key, ...val });
  });

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            p: 1,
          }}
        >
          {/* PASSING */}
          <GroupLabel title="Passing (Green tones)" />
          {grouped.passing.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* SHOOTING */}
          <GroupLabel title="Shooting (Red / Orange tones)" mt />

          {grouped.shooting.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* DEFENDING */}
          <GroupLabel title="Defending (Blue tones)" mt />

          {grouped.defending.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* GK */}
          <GroupLabel title="Goalkeeping (Purple / Amber)" mt />

          {grouped.goalkeeping.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            background: "var(--surface-1)",
            border: "1px solid var(--border-1)",
            borderRadius: "8px",
            maxWidth: 260,
            p: 1,
            color: "var(--text-1)",
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          },
        },
        arrow: {
          sx: { color: "var(--surface-1)" },
        },
      }}
    >
      <IconButton
        size="small"
        sx={{
          color: "var(--text-2)",
          border: "1px solid var(--border-1)",
          borderRadius: "50%",
          width: 26,
          height: 26,
          "&:hover": { backgroundColor: "var(--surface-2)", color: "var(--text-1)" },
        }}
      >
        <InfoOutlined sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
};

const GroupLabel = ({ title, mt }) => (
  <Typography
    fontWeight={700}
    fontSize={12}
    sx={{ mt: mt ? 1 : 0.2, mb: 0.5, color: "var(--text-1)" }}
  >
    {title}
  </Typography>
);

const LegendRow = ({ item }) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={0.4}>
    <Box sx={{ width: 12, height: 12, borderRadius: "3px", background: item.color, flexShrink: 0 }} />
    <Typography sx={{ width: 48, fontSize: 12, fontWeight: 600, color: "var(--text-1)" }}>
      {item.code}
    </Typography>
    <Typography sx={{ fontSize: 12, color: "var(--text-2)" }}>{item.label}</Typography>
  </Stack>
);

const styles = {
  header: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 54,
      backgroundColor: "var(--surface-1)",
      padding: "0 20px",
      borderBottom: "1px solid var(--border-1)",
      position: "sticky",
      top: 0,
      zIndex: 100,
    },
    side: {
      width: 48,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 6,
    },
    score: {
      color: "var(--primary-1)",
      fontWeight: "700",
      fontSize: 15,
      letterSpacing: "0.02em",
    },
    matchInfo: {
      color: "var(--text-2)",
      fontSize: 14,
      fontWeight: 500,
    },
    logout: {
      color: "#FF5A1F",
      cursor: "pointer",
      fontWeight: "500",
    },
  },

  cardContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    padding: "10px 20px",
  },

  card1: {
    card: {
      flex: "1.4 1 220px",
      minWidth: 0,
      height: 72,
      borderRadius: 10,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      display: "flex",
      width: "100%",
      padding: "0 20px",
      justifyContent: "space-between",
      alignItems: "center",
    },
    team: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      width: "46%",
    },
    teamNameText: {
      fontWeight: "700",
      fontSize: 12,
      color: "var(--text-1)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    },
    teamBoxA: { padding: "2px 0" },
    teamBoxB: { padding: "2px 0", alignItems: "flex-end" },
    label: {
      fontWeight: 400,
      fontSize: 9,
      color: "var(--text-2)",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
  },

  card2: {
    card: {
      flex: "1.6 1 300px",
      minWidth: 0,
      height: 72,
      overflow: "hidden",
      borderRadius: 10,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      width: "100%",
      height: "100%",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
      gap: 8,
      boxSizing: "border-box",
    },
    box: {
      backgroundColor: "rgba(12, 157, 65, 0.1)",
      padding: "6px 8px",
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minWidth: 36,
      flexShrink: 0,
    },
    id: {
      fontWeight: 700,
      fontSize: 14,
      color: "rgba(12, 157, 65, 1)",
    },
    textRight: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      minWidth: 0,
      flexShrink: 1,
    },
    name: {
      fontWeight: 600,
      color: "var(--text-1)",
      fontSize: 12,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    label: {
      fontSize: 9,
      color: "var(--text-2)",
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      whiteSpace: "nowrap",
    },
    divider: {
      width: 1,
      height: 48,
      backgroundColor: "var(--border-1)",
      flexShrink: 0,
    },
    reviewers: {
      flex: 1,
      minWidth: 0,
      maxHeight: 64,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    },
    reviewerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 6,
      fontSize: 10,
      lineHeight: "14px",
      color: "var(--text-1)",
    },
    reviewerName: {
      fontWeight: 600,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: 0,
    },
  },

  card3: {
    card: {
      flex: "1 1 150px",
      minWidth: 0,
      height: 72,
      borderRadius: 10,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      padding: "0 14px",
      gap: 8,
    },
    title: {
      fontWeight: 500,
      color: "var(--text-2)",
      fontSize: 10,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
    time: {
      color: "#FF5A1F",
      fontWeight: 700,
      fontSize: 16,
      letterSpacing: "0.02em",
    },
    progressBar: { width: 60 },
    timeProgressWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 16,
    },
  },

  urlCard: {
    wrapper: {
      padding: "8px 16px",
      borderRadius: 10,
      backgroundColor: "var(--surface-1)",
      border: "1px solid var(--border-1)",
      margin: "0 20px 10px 20px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 12,
    },
  },

  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "var(--surface-1)",
    marginBottom: "1rem",
  },
  videoContainer: {
    width: "100%",
    borderRadius: "10px",
    border: "1px solid var(--border-1)",
    overflow: "hidden",
    backgroundColor: "var(--surface-1)",
  },
  videoTimeline: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingHorizontal: "8px",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "var(--surface-2)",
    borderTop: "1px solid var(--border-1)",
  },
  controlContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "var(--surface-1)",
    borderTop: "1px solid var(--border-1)",
    paddingHorizontal: "12px",
    paddingVertical: "8px",
  },
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SetControllerToggle,
  ClearSeekFlag,
})(TechQC);
